import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Entities from "../../components/Entities";
import { MonthInput } from "../../components/month_picker/MonthInput/MonthInput";
import { MonthPicker } from "../../components/month_picker/MonthPicker/MonthPicker";
import { getHotSheets } from "../../API";

function currentMonthObj() {
  const now = new Date();
  return [{ month: now.getMonth() + 1, year: now.getFullYear(), monthName: now.toLocaleString("en", { month: "short" }) }];
}

function toMonthObj(monthStr) {
  if (!monthStr) return currentMonthObj();
  const [yearStr, monthStr2] = monthStr.split("-");
  const year = parseInt(yearStr);
  const m = parseInt(monthStr2);
  return [{ month: m, year, monthName: new Date(year, m - 1).toLocaleString("en", { month: "short" }) }];
}

function fromMonthObj(months) {
  if (!months || months.length === 0) return "";
  const { month, year } = months[0];
  return `${year}-${String(month).padStart(2, "0")}`;
}

export async function loader({ request }) {
  const url = new URL(request.url);
  const month = url.searchParams.get("month") || fromMonthObj(currentMonthObj());
  return getHotSheets(month);
}

function HotSheets() {
  const [searchParams, setSearchParams] = useSearchParams();
  const monthStr = searchParams.get("month") || fromMonthObj(currentMonthObj());
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  function handleMonthChange(months) {
    setSearchParams({ month: fromMonthObj(months) });
    setIsPickerOpen(false);
  }

  const monthPicker = (
    <div style={{ position: "relative" }}>
      <MonthInput
        selected={toMonthObj(monthStr)}
        setShowMonthPicker={setIsPickerOpen}
        showMonthPicker={isPickerOpen}
        size="small"
      />
      {isPickerOpen && (
        <MonthPicker
          setIsOpen={setIsPickerOpen}
          selected={toMonthObj(monthStr)}
          onChange={handleMonthChange}
        />
      )}
    </div>
  );

  return (
    <Entities
      extraFilters={monthPicker}
      shema={{
        searchFromServer: false,
        fields: [
          { name: "Name", propertyName: "name", search: true },
          { name: "Month", propertyName: "month" },
          { name: "Manufacturer", propertyName: "manufacturer", isObject: true },
        ],
      }}
    />
  );
}

export default HotSheets;
